import { Check, X } from 'lucide-react';
import { Button } from '../../../../../design-system/button/button';
import { Inline } from '../../../../../design-system/inline/inline';

type SelectedRowApproveButtonProps = {
  selectedRowCount: number;
  isLoading: boolean;
  onApprove: () => void;
  onClose: () => void;
};

export const SelectedRowApproveButton = ({
  selectedRowCount,
  isLoading,
  onApprove,
  onClose,
}: SelectedRowApproveButtonProps) => {
  return (
    <Inline
      space={8}
      justify="between"
      className="sticky bottom-5 left-1/2 w-max -translate-x-1/2 rounded-full border-[0.5px] border-border bg-white px-6 py-3"
    >
      <p className="text-sm leading-6 font-medium tracking-tight text-black">{selectedRowCount} selected:</p>

      <Inline space={4}>
        <Button variant="default" iconLeft={<Check size={16} />} isLoading={isLoading} onClick={onApprove}>
          Approve all
        </Button>

        <Button variant="ghost" size="none" onClick={onClose} disabled={isLoading} aria-label="Close">
          <div className="h-5 w-5">
            <X className="h-full w-full" />
          </div>
        </Button>
      </Inline>
    </Inline>
  );
};
